// Runtime configuration.
//
// Deployed: docker-entrypoint.sh writes /env-config.js at container start, setting
//   window._env_ = { VITE_API_URL, VITE_COGNITO_USER_POOL_ID, ... }
// from the container's environment. index.html loads it before the app bundle, so a
// single build artifact runs in dev / pr / staging / prod with per-deploy config —
// no environment values baked at build time.
//
// Local `npm run dev`: public/env-config.js ships an empty window._env_, so we fall
// back to Vite's build-time import.meta.env (from .env.development). Nothing changes
// for local development.

const injected = (typeof window !== 'undefined' && window._env_) || {};

// A key present in window._env_ wins even when its value is '' (an empty VITE_API_URL
// deliberately means "same-origin /api, proxied by nginx"). Otherwise fall back to the
// build-time value, then the provided default.
function pick(key, fallback = '') {
  if (key in injected) return injected[key];
  const built = import.meta.env[key];
  return built !== undefined ? built : fallback;
}

export const API_URL = pick('VITE_API_URL', '');
export const AWS_REGION = pick('VITE_AWS_REGION', 'eu-north-1');
export const COGNITO_USER_POOL_ID = pick('VITE_COGNITO_USER_POOL_ID');
export const COGNITO_CLIENT_ID = pick('VITE_COGNITO_CLIENT_ID');
export const getConfig = pick;
